import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { I18n } from '@/i18n/I18n';
import { Plus } from 'lucide-react';
import { VerificationCriteriaPanel } from './VerificationCriteriaPanel';

interface AddVerificationCriteriaButtonProps {
  requirementId: string;
  btnSize: 'small' | 'medium';
}

export function AddVerificationCriteriaButton({ requirementId, btnSize }: AddVerificationCriteriaButtonProps) {
  const [showPanel, setShowPanel] = useState(false);

  return (
    <>
      <Button
        className={`fusa-btn-${btnSize}-with-icon fusa-btn-primary`}
        size="sm"
        onClick={() => setShowPanel(true)}
        aria-label={I18n.get('addCriteria')}
      >
        <Plus size={16} />
        {I18n.get('addCriteria')}
      </Button>
      {showPanel && (
        <VerificationCriteriaPanel
          onHide={() => setShowPanel(false)}
          requirementId={requirementId}
        />
      )}
    </>
  );
}
